require("./snippets/accordion");
require("./snippets/product-quick-view-modal");
require("./snippets/mega-menu-images");
require("./qf/global_listeners");
// require("./qf/wishlist");
require("./qf/wishlistAsObject");
require("./qf/cart");
require("./qf/loadMore");
require("./qf/mobileMenuHeight");
require("./qf/ModalController");

window.modalController = new ModalController()
// window.wishlist = new WishlistQf();
window.wishlist = new WishlistObjectQf();
window.globalListeners = new GlobalListeners();
window.cart = new CartQf();